<ra-modal
    [title]="'order.archivedPanel.title' | translate"
    [animation]="'slide-right'"
    (close)="close.emit()">

    <div class="container-search">
        <ra-input
            [id]="'input-search-archived-orders'"
            [placeholder]="'order.archivedPanel.searchPlaceholder' | translate"
            [formControl]="searchControl"
            [showRequiredOrOptional]="false"
            [loading]="(feedMode() ? feedLoading() : orderMainService.loadingArchived()) && !!searchControl.value"
        />
    </div>

    @if (feedMode()) {
        <!-- Modo FEED: arquivados mistos (grupos + documentos avulsos) -->
        @if (feedLoading() && !feedItems().length) {
            <div class="container-loading">
                <ra-loading [size]="'small'" />
            </div>
        }
        @else if (!feedItems().length) {
            <ra-empty
                [title]="'order.archivedPanel.emptyTitle' | translate"
                [message]="'order.archivedPanel.emptyMessage' | translate"
            />
        }
        @else {
            <div class="container-archived-list">
                @for (item of feedItems(); track item._id) {
                    <div class="archived-order-row">
                        <div class="archived-order-info">
                            <p class="ra-label-s bold">{{ feedItemTitle(item) }}</p>
                            <p class="ra-label-xs content-secondary">
                                <!-- Título é o cliente; a descrição (se houver) vira subtítulo -->
                                @if (item.type === feedItemTypeEnum.GROUP) {
                                    {{ item.description?.trim() || ('order.common.noDescription' | translate) }}
                                }
                                @else {
                                    {{ 'order.feed.standaloneBadge' | translate }}
                                }
                            </p>
                        </div>

                        <!-- Código da OS: só o grupo tem um; o avulso mora numa
                             order pessoal, cujo código não diz nada ao usuário. -->
                        @if (item.type === feedItemTypeEnum.GROUP && item.code) {
                            <ra-badge
                                [label]="'order.common.codeLabel' | translate: { code: item.code }"
                                [variant]="'primary'"
                                [size]="'small'"
                            />
                        }

                        @if (restoringOrderId() === item._id) {
                            <ra-loading [size]="'small'" />
                        }
                        @else {
                            <ra-square-icon
                                [id]="'square-icon-restore-' + item._id"
                                [icon]="'rotate-right'"
                                [tooltip]="'order.archivedPanel.restoreTooltip' | translate"
                                [tooltipPosition]="'left'"
                                (click)="restoreFeedItem(item)"
                            />
                        }
                    </div>
                }
            </div>
        }
    }
    @else if (orderMainService.loadingArchived() && !orderMainService.archivedOrders().length) {
        <div class="container-loading">
            <ra-loading [size]="'small'" />
        </div>
    }
    @else if (!orderMainService.archivedOrders().length) {
        <ra-empty
            animate.enter="empty-enter"
            [title]="'order.archivedPanel.emptyTitle' | translate"
            [message]="'order.archivedPanel.emptyMessage' | translate"
        />
    }
    @else {
        <div class="container-archived-list">
            @for (order of orderMainService.archivedOrders(); track order._id) {
                <div class="archived-order-row">
                    <div class="archived-order-info">
                        <p class="ra-label-s bold">{{ order?.client?.name || ('order.common.clientNotFound' | translate) }}</p>
                        <p class="ra-label-xs content-secondary">{{ order?.description || ('order.common.noDescription' | translate) }}</p>
                    </div>

                    @if (order?.code) {
                        <ra-badge
                            [label]="'order.common.codeLabel' | translate: { code: order.code }"
                            [variant]="'primary'"
                            [size]="'small'"
                        />
                    }

                    @if (restoringOrderId() === order._id) {
                        <ra-loading [size]="'small'" />
                    }
                    @else {
                        <ra-square-icon
                            [id]="'square-icon-restore-' + order._id"
                            [icon]="'rotate-right'"
                            [tooltip]="'order.archivedPanel.restoreTooltip' | translate"
                            [tooltipPosition]="'left'"
                            (click)="restoreOrder(order._id)"
                        />
                    }
                </div>
            }
        </div>

        @if (orderMainService.loadingArchived()) {
            <div class="container-load-more">
                <ra-loading [size]="'small'" />
            </div>
        }
        @else if (orderMainService.archivedPaginate()?.page < orderMainService.archivedPaginate()?.totalPages) {
            <div class="container-load-more">
                <ra-button
                    [label]="'order.common.loadMore' | translate"
                    [type]="'primary'"
                    (click)="getOrders(orderMainService.archivedPaginate()?.page + 1)" />
            </div>
        }
    }
</ra-modal>
